export default __webpack_public_path__ + "static/media/email.8b073d1e.png";